WiseMetering.Views.CircuitAutomation = Backbone.Marionette.ItemView.extend({
    events: {
        'click #edit-schedule': 'editSchedule'
    },
    modelEvents: {
        'change': 'render'
    },
    template: 'templates/circuits/automation',
    ui: {
        schedule: '#circuit-schedule'
    },

    editSchedule: function(event) {
        event.preventDefault();
        new WiseMetering.Views.EditCircuitSchedule({ model: this.model });
    },

    onRender: function() {
        const view = new WiseMetering.Views.CircuitScheduleHistory({ model: this.model });
        view.render();
        this.ui.schedule.html(view.el);
    }
});
